const getProductId = state => state.productPage.productId;
const isAccessory = state => state.productPage.productId && state.productPage.isAccessory;
const isFoam = state => state.productPage.productId && state.productPage.isFoam;

export default {
  getProductId,
  isAccessory,
  isFoam
};
